import { h } from '@stencil/core';
export class AibaMaskCarousel {
  constructor() {
    this.createCustomMask = (DATA, svg, i) => {
      const masking = this.maskinData;
      if (DATA) {
        DATA.forEach(function (target) {
          //Set viewBox
          svg.setAttribute('viewBox', target.view_box);
          target.features.forEach(function (d) {
            d.geometry.coordinates.forEach(function (c) {
              let object = null;
              //Polygon
              if (d.geometry.type === 'MultiPolygon' || d.geometry.type === 'MultiLineString') {
                object = svg.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'polygon'));
                object.setAttribute('points', c[0]);
              }
              //Point
              if (d.geometry.type === 'MultiPoint') {
                object = svg.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'circle'));
                object.setAttribute('cx', c[0]);
                object.setAttribute('cy', c[1]);
                object.setAttribute('r', c[2]);
              }
              //intensity
              if (masking[i].opacity) {
                object.style.opacity = masking[i].opacity;
              }
              else {
                object.style.opacity = d.geometry.intensity;
              }
              //fill
              if (masking[i] && masking[i].color) {
                if (i === '33') {
                  target.fill = this.maskingID[i].color[target.tech_name];
                }
                else {
                  target.fill = this.maskingID[i].color;
                }
              }
              //stroke
              if (masking[i].stroke) {
                target.stroke = masking[i].stroke;
              }
              object.style.fill = target.fill || 'transparent';
              object.style.stroke = target.stroke || 'transparent';
            });
          });
        });
      }
    };
    this.createMasks = (DATA, svg, i) => {
      const masking = this.maskinData;
      if (DATA) {
        DATA.forEach(function (target) {
          //Set viewBox
          svg.setAttribute('viewBox', target.view_box);
          target.features.forEach(function (d) {
            d.geometry.coordinates.forEach(function (c) {
              let object = null;
              //Polygon
              if (d.geometry.type === 'MultiPolygon' || d.geometry.type === 'MultiLineString') {
                object = svg.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'polygon'));
                object.setAttribute('points', c[0]);
              }
              //Point
              if (d.geometry.type === 'MultiPoint') {
                object = svg.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'circle'));
                object.setAttribute('cx', c[0]);
                object.setAttribute('cy', c[1]);
                object.setAttribute('r', c[2]);
              }
              //intensity
              if (masking[i].opacity) {
                object.style.opacity = masking[i].opacity;
              }
              else {
                object.style.opacity = d.geometry.intensity;
              }
              //fill
              if (masking[i] && masking[i].color) {
                if (i === '33') {
                  target.fill = this.maskingID[i].color[target.tech_name];
                }
                else {
                  target.fill = this.maskingID[i].color;
                }
              }
              //stroke
              if (masking[i].stroke) {
                target.stroke = masking[i].stroke;
              }
              object.style.fill = target.fill || 'transparent';
              object.style.stroke = target.stroke || 'transparent';
            });
          });
        });
      }
    };
    this.getMasksId = async (masks) => {
      const maskID = await masks.reduce((total, curr) => {
        if (curr.masks && this.maskinData[curr.algorithmVersionId.toString()] && curr.masks.original) {
          this.maskingID.indexOf(curr.algorithmVersionId.toString()) > -1 && total.push(curr.algorithmVersionId.toString());
        }
        return total;
      }, []);
      return maskID;
    };
    this.data = undefined;
    this.styles = undefined;
    this.handlers = undefined;
    this.carouselData = undefined;
    this.imageAlgorithmId = null;
    this.imageHolderRef = [];
    this.customImageHolderRef = undefined;
    this.carouselStateObject = undefined;
    this.skinConfig = undefined;
    this.svg = undefined;
    this.maskingID = undefined;
    this.maskinData = undefined;
    this.reRender = false;
    this.customMask = undefined;
    this.imageData = undefined;
  }
  handleMaskChange(event) {
    if (event.detail && event.detail.length > 0) {
      this.carouselStateObject['concernMaskAreas'] = event.detail[0];
      this.imageAlgorithmId = [event.detail[0].algorithmVersionId];
      this.reRender = !this.reRender;
      this.customMask = this.imageAlgorithmId[0];
    }
  }
  renderCustomMask() {
    var _a;
    const renderValue = this.carouselData ? (h("aiba-carousel", Object.assign({}, this.carouselData, { handleSliderNext: event => this.handlers && this.handlers.handleMaskSliderNext & this.handlers.handleMaskSliderNext(event), handleSliderPrev: event => this.handlers && this.handlers.handleMaskSliderPrev & this.handlers.handleMaskSliderPrev(event) }), (_a = this.imageAlgorithmId) === null || _a === void 0 ? void 0 : _a.map(index => (h("div", { role: "figure", class: "image-holder", ref: el => (this.customImageHolderRef = el), "data-lable": this.maskinData[index].label }, h("img", Object.assign({}, this.imageData, { src: this.carouselStateObject.selfieImage, alt: this.carouselStateObject.userPI.name }))))))) : (h("div", { role: "figure", class: "image-holder", ref: el => (this.customImageHolderRef = el) }, h("img", Object.assign({}, this.imageData, { src: this.carouselStateObject.selfieImage, alt: this.carouselStateObject.userPI.name }))));
    this.initiateCustomMask();
    return renderValue;
  }
  initiateCustomMask() {
    const imageHolderRef = this.customImageHolderRef;
    let index;
    if (imageHolderRef) {
      imageHolderRef.querySelector('svg') && imageHolderRef.querySelector('svg').remove();
      const data = this.carouselStateObject.skinAnalysisResults.reduce((total, i) => {
        if (i.masks && i.algorithmVersionId && this.imageAlgorithmId.indexOf(i.algorithmVersionId.toString()) !== -1) {
          total = i.masks.original;
          index = parseInt(i.algorithmVersionId);
        }
        return total;
      }, {});
      this.svg = imageHolderRef.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'svg'));
      const svgWidth = imageHolderRef.querySelector('img').naturalWidth;
      const svgHeight = imageHolderRef.querySelector('img').naturalHeight;
      this.svg.setAttribute('width', '100%');
      this.svg.setAttribute('height', '100%');
      this.svg.setAttribute('viewBox', `0 0 ${svgWidth} ${svgHeight}`);
      if (Object.keys(data).length && this.skinConfig.enableMasking) {
        if (data) {
          this.createCustomMask(data, this.svg, index);
        }
      }
    }
    else {
      return false;
    }
  }
  initiateMask() {
    const imageHolderRef = this.imageHolderRef;
    if (imageHolderRef.length > 0) {
      imageHolderRef.forEach((elem, index) => {
        elem.querySelector('svg') && elem.querySelector('svg').remove();
        const data = this.carouselStateObject.skinAnalysisResults.reduce((total, i) => {
          if (i.masks && i.algorithmVersionId && this.imageAlgorithmId.indexOf(i.algorithmVersionId.toString()) !== -1) {
            total[i.algorithmVersionId] = i.masks.original;
          }
          return total;
        }, {});
        this.svg = elem.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'svg'));
        const svgWidth = elem.querySelector('img').naturalWidth;
        const svgHeight = elem.querySelector('img').naturalHeight;
        this.svg.setAttribute('width', '100%');
        this.svg.setAttribute('height', '100%');
        this.svg.setAttribute('viewBox', `0 0 ${svgWidth} ${svgHeight}`);
        if (Object.keys(data).length && this.skinConfig.enableMasking) {
          if (data[index]) {
            this.createMasks(data[index], this.svg, index);
          }
        }
      });
    }
    else {
      return false;
    }
  }
  async componentWillLoad() {
    this.maskinData = await this.handlers.getMaskingData();
    this.maskingID = await this.handlers.getHautSkinAnalyserMaskingId();
    this.carouselStateObject = await this.handlers.getHautCarouselStateObject();
    this.skinConfig = await this.handlers.getSkinAnalyserAppConfig();
    if (this.skinConfig.showMaskingConcernAreaOnly) {
      this.imageAlgorithmId = await this.getMasksId(this.carouselStateObject.concernMaskAreas);
    }
    else {
      this.imageAlgorithmId = await this.getMasksId(this.carouselStateObject.skinAnalysisResults);
    }
  }
  async componentDidLoad() {
    this.initiateMask();
  }
  getMaskingSlides() {
    var _a;
    return this.carouselData ? (h("aiba-carousel", Object.assign({}, this.carouselData, { handlers: this.handlers, handleSliderNext: event => this.handlers && this.handlers.handleMaskSliderNext & this.handlers.handleMaskSliderNext(event), handleSliderPrev: event => this.handlers && this.handlers.handleMaskSliderPrev & this.handlers.handleMaskSliderPrev(event) }), (_a = this.imageAlgorithmId) === null || _a === void 0 ? void 0 : _a.map(index => {
      var _a, _b, _c;
      return (h("div", { role: "figure", class: "image-holder", ref: el => (this.imageHolderRef[index] = el), "data-lable": this.maskinData[index].label, "data-heading": (_a = this.maskinData[index]) === null || _a === void 0 ? void 0 : _a.heading, "data-score": (_b = this.maskinData[index]) === null || _b === void 0 ? void 0 : _b.score, "data-description": (_c = this.maskinData[index]) === null || _c === void 0 ? void 0 : _c.description }, h("img", Object.assign({}, this.imageData, { src: this.carouselStateObject.selfieImage, alt: this.carouselStateObject.userPI.name }))));
    }))) : (h("div", { role: "figure", class: "image-holder", ref: el => (this.imageHolderRef[0] = el) }, h("img", Object.assign({}, this.imageData, { src: this.carouselStateObject.selfieImage, alt: this.carouselStateObject.userPI.name }))));
  }
  render() {
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    return (h("div", { class: "masking-model" }, this.data &&
      this.data['elements'].map(element => {
        if (element && element['name'] === 'image-data') {
          this.imageData = element['data'];
        }
        if (element && element['name'] === 'aiba-carousel' && !this.customMask) {
          this.carouselData = element;
          return this.getMaskingSlides();
        }
        if (element && element['name'] === 'aiba-custom-mask-carousel' && this.customMask) {
          this.carouselData = element;
          return this.renderCustomMask();
        }
        if (element && element['name'] === 'aiba-single-mask-image' && this.customMask) {
          return this.renderCustomMask();
        }
      })));
  }
  static get is() { return "aiba-mask-carousel"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-mask-carousel.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-mask-carousel.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "styles": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "carouselData": {},
      "imageAlgorithmId": {},
      "imageHolderRef": {},
      "customImageHolderRef": {},
      "carouselStateObject": {},
      "skinConfig": {},
      "svg": {},
      "maskingID": {},
      "maskinData": {},
      "reRender": {},
      "customMask": {},
      "imageData": {}
    };
  }
  static get listeners() {
    return [{
        "name": "event-donut-click-custom",
        "method": "handleMaskChange",
        "target": "window",
        "capture": true,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-mask-carousel.js.map
